@if (info.actions) {
  <div class="modal__actions">
    @if (!info.actions.cancel?.content && info.actions.cancel?.id) {
      <button
        [id]="info.actions.cancel.id"
        (click)="clickCloseModal()"
        class="link new-link--back modal-btn"
        [disabled]="loadingInfo.condition">
        {{ 'GENERAL.CANCEL' | translate }}
      </button>
    }
    <ng-container [ngTemplateOutlet]="customActionBtnContent"></ng-container>
    <ng-container [ngTemplateOutlet]="closeModalBtnContent"></ng-container>
    @if (info.actions.submitWithClothing?.id && submitWithClothingBtnText) {
      <button
        [id]="info.actions.submitWithClothing.id"
        (click)="clickCloseModal(true)"
        class="btn btn--new-primary small modal-btn"
        [ngClass]="info.actions.submitWithClothing.extraClass"
        [disabled]="loadingInfo.condition || info.actions.submitWithClothing.disabled">
        <span class="btn__text">
          {{ submitWithClothingBtnText | translate }}
        </span>
      </button>
    }
    @if (info.actions.submit?.id && submitBtnText) {
      <button
        [id]="info.actions.submit.id"
        type="submit"
        class="btn btn--new-primary small modal-btn"
        [ngClass]="info.actions.submit.extraClass"
        [disabled]="
          info.actions.submit.disabled ||
          (info.actions.considerDataChange && formUnchangedInfo.condition) ||
          loadingInfo.condition
        "
        (click)="clickOnSubmit()">
        <span class="btn__text">
          {{ submitBtnText | translate }}
        </span>
      </button>
    }
    <ng-container [ngTemplateOutlet]="submitWithClothingContent"></ng-container>
  </div>
}
